import { Fragment, useEffect, useRef, useState } from 'react';
import './Timer.scss';

const timeHeaders = ["days", "hours", "minutes", "seconds"];

const Timer = ({type, claimTime, onTimeOver, useFormat = true}) => {
    const moment = require('moment');
    const [time, setTime] = useState(moment.duration(moment.utc(claimTime).diff(moment.utc()), "milliseconds"));
    const intervalRef = useRef();
  
    useEffect(() => {
      if(time === "over") return;
      if(time.asSeconds() < 0) {
        if(onTimeOver) {
          setTime("over");
          onTimeOver(time.asSeconds());
        }
        return;
      };

      intervalRef.current = setTimeout(() => {
        setTime(prevTime => prevTime.clone().subtract(1000, 'milliseconds'))
      }, 1000)
  
      return () => {
        clearInterval(intervalRef.current)
        intervalRef.current = null
      }
      //eslint-disable-next-line
    }, [time]);

    useEffect(() => {
      const _claimTime = moment.duration(moment(claimTime).diff(moment.utc()), "milliseconds");
      if(time !== "over" || _claimTime.asSeconds() < 0) return;
      setTime(moment.duration(moment(claimTime).diff(moment.utc()), "milliseconds"));
      //eslint-disable-next-line
    }, [claimTime, time]);
    
    const renderTimerView = () => {
      if(time === "over") return `00:00:00:00`;
      if(useFormat) {
        if(type === "custom") {
          const timeData = `${time.days() < 10 && "0"}${time.days()}:${moment.utc(time.as('milliseconds')).format('HH:mm:ss')}`;
          return <div className="timer-custom-component">
            {timeData.split(':').map((_t, index) => {
              return (<Fragment key={index}> 
                {index !== 0 && <span className="timer-custom-component__splitter">:</span>}
                <span className="timer-custom-component__time-block"><span>{_t}</span><small>{timeHeaders[index]}</small></span>
              </Fragment>)
            })}
          </div>
        }
        return `${time.days()}d ${time.hours()}h ${time.minutes()}m ${time.seconds()}s`
      }
      return time;
    }

    return renderTimerView();
};

export default Timer;